import request from "../util/request";

/**
 * 获取验证码
 * @param data
 * @returns {Promise<void>}
 */
export async function getAuthCode(data) {
  return request("/api/sms/sendCaptcha", {
    method: "POST",
    data,
  });
}

/**
 * 获取验证码
 * @param data
 * @returns {Promise<void>}
 */
export async function register(data) {
  return request("/api/promotion/promotionRegister", {
    method: "POST",
    data,
  });
}
